<template>
  <v-list-item dense class="pl-0" :class="item.IsActive ? '' : 'deactivated'" @click="$emit('click')">
    <v-list-item-icon class="ma-0 mr-3">
      <MachineModelImage :size="40" :relativePath="item.ModelImage" />
    </v-list-item-icon>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ item.Name }}
      </v-list-item-title>
      <v-list-item-subtitle v-if="item.AlternativeName != item.Name">
        {{ item.AlternativeName }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ item.MachineType && item.MachineType.Name }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ item.Supplier && item.Supplier.Name }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";

export default {
  name: 'MachineModelListItem',
  props: {
    item: Object,
  },
  components: {
    MachineModelImage,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>